import { z } from 'zod';

export type TModalVariants = 'vacancy' | 'users' | 'candidate' | 'company';

export type ExportDataResponse = {
  data: Blob;
  filename: string;
};

export type ExportDataFunction = (params: {
  dateFrom: string | null;
  dateTo: string | null;
}) => Promise<ExportDataResponse>;

export type UseDataExportProps = {
  type: TModalVariants;
  title: string;
  text: string;
  isPending: boolean;
  exportData: ExportDataFunction;
};

export type UseDataExportComponentProps = {
  MODAL_ID: string;
  type: TModalVariants;
  isPending: boolean;
  exportData: ExportDataFunction;
  text: string;
};

export const $DataExportSchema = z
  .object({
    periodType: z.enum(['all', 'range']),
    startDate: z.date().nullable(),
    endDate: z.date().nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.periodType === 'range') {
      if (!data.startDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Укажите начальную дату',
          path: ['startDate'],
        });
      }

      if (!data.endDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Укажите конечную дату',
          path: ['endDate'],
        });
      }

      if (data.startDate && data.endDate && data.endDate < data.startDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Конечная дата не может быть раньше начальной',
          path: ['endDate'],
        });
      }
    }
  });

export type DataExportSchema = z.infer<typeof $DataExportSchema>;
